import styled from 'styled-components';

export const WaitListWrapper = styled.div`
  overflow-y: auto;
  max-height: 280px;
`;
